import React from 'react';
import PropTypes from 'prop-types';
import styles from './style.css';
import '../../reset.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng-fe/errorBoundary';

class NavigationInner extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };
    /**
     * 渲染组件
     */
    render() {
        const { content } = this.props;
        const leftContent = content.filter((item, index) => index < 4);
        const rightContent = content.filter((item, index) => index > 3);

        const leftNavigation = leftContent.map((item, index) => (
            <li key={index}>
                <a href={item.url} title={item.title}>
                    {item.title}
                </a>
            </li>
        ));
        const rightNavigation = rightContent.map((item, index) => (
            <li key={index}>
                <a href={item.url} title={item.title}>
                    {item.title}
                </a>
            </li>
        ));

        return (
            <div className={styles.clearfix}>
                <ul className={`${styles.list01} clearfix`} style={{ width: '339px', marginLeft: '82px' }}>
                    {leftNavigation}
                </ul>
                <ul
                    className={`${styles.list01} ${styles.m02} clearfix`}
                    style={{ width: '360px', marginLeft: '173px' }}>
                    {rightNavigation}
                </ul>
            </div>
        );
    }
}

class Banner extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { content } = this.props;

        return <div className={styles.banner01} style={{ background: `url(${content.src}) top center no-repeat` }} />;
    }
}

class Navigation extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };
    render() {
        const { content } = this.props;

        const { banner, navigation } = content;

        return (
            <div className={styles.header01}>
                <Chip id="200053" type="struct" title="顶部banner" groupName="赛事战报头部" content={banner}>
                    <Banner />
                </Chip>

                <div className={styles.h1000}>
                    <div className={styles.spance01} />
                    <Chip id="230047" type="struct" title="导航" groupName="赛事战报头部" content={navigation}>
                        <NavigationInner />
                    </Chip>
                    <div className={styles.shouye01}>
                        <a href="http://ds.ifeng.com/" target="_self" />
                    </div>
                </div>
            </div>
        );
    }
}

export default errorBoundary(Navigation);
